export default __webpack_public_path__ + "static/media/Employee Benefits.24b16873.svg";